import MomentUtils from "@date-io/moment";
import Button from "@material-ui/core/Button";
import {
	MuiThemeProvider,
	makeStyles,
} from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import {
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { SnackbarProvider } from "notistack";
import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import AuthOrApp from "../AuthOrApp";
import theme from "../commons/layout/theme";
import NotificationsWrapper from "../commons/NotificationsWrapper";
import PublicSnackbarListener from "../commons/PublicSnackbarListener";
import LoginForm from "../LoginForm";
import Home from "../publicViews/Home";
import Login from "../publicViews/Login";
import Unauthorized from "../publicViews/Unauthorized";
import MonitorPedidosPendentes from "../commons/MonitorPedidosPendentes";
import MenuEnabledGuard from "../commons/MenuEnabledGuard";
import { RemoteConfigProvider } from "../state/remoteConfig/RemoteConfigContext";
import Auditoria from "../views/components/Auditoria";
import Dashboard from "../views/components/Dashboard";
import Debugger from "../views/components/Debugger";
import EmSeparacao from "../views/components/EmSeparacao";
import Historico from "../views/components/Historico";
import ErrorBoundary from "../views/components/helpers/ErrorBoundary";
import Maintenance from "../views/components/Maintenance";
import NovosPedidos from "../views/components/NovosPedidos";
import OrderDetails from "../views/components/OrderDetails";
import Previstos from "../views/components/Previstos";
import RetornarEstoque from "../views/components/RetornarEstoque";
import ReadyToGo from "../views/components/ready-to-go/ReadyToGo";
import SaiuEntrega from "../views/components/SaiuEntrega";
import TodosPedidos from "../views/components/TodosPedidos";
import consts from "./consts";
import { StorageUser } from "./StorageUser";

const useSnackbarStyles = makeStyles({
	containerTopRight: {
		right: 0,
	},
});

//CONSULT_RESCUE
export default (props) => {
	const { auth } = useSelector((state) => {
		return state;
	});

	const { token, lojas } = useSelector((state) => state.auth);
	const notistackRef = React.useRef();
	const snackbarClasses = useSnackbarStyles();
	const onClickDismiss = (key) => () => {
		notistackRef.current.closeSnackbar(key);
	};

	const renderLoginForm = (props) => {
		if (process.env.NODE_ENV !== "production" || consts.ENABLE_LOGIN) {
			return (
				<Route
					exact
					path={`${consts.CONTEXT}/login-form`}
					component={(props) => <LoginForm {...props} />}
				/>
			);
		} else {
			return <></>;
		}
	};

	const renderRoute = (props) => {
		const storageUser = new StorageUser();
		const noStores = !lojas || lojas.length === 0;

		return (
			<MuiThemeProvider theme={theme}>
				<BrowserRouter>
					<SnackbarProvider
						maxSnack={3}
						ref={notistackRef}
						classes={{
							containerAnchorOriginTopRight: snackbarClasses.containerTopRight,
						}}
						action={(key) => (
							<Button onClick={onClickDismiss(key)}>
								<CloseIcon fontSize="small" color="action" />
							</Button>
						)}
					>
						{!auth.isLoggingIn ? (
							<>
								<PublicSnackbarListener />
								<Switch>
									{renderLoginForm(props)}
									<Route
										exact
										path={`/home`}
										component={(props) => <Home {...props} />}
									/>
									<Route
										exact
										path={`${consts.CONTEXT}/home`}
										component={(props) => <Home {...props} />}
									/>
									<Route
										exact
										path={`/login`}
										component={(props) => <Login {...props} />}
									/>
									<Route
										exact
										path={`${consts.CONTEXT}/login`}
										component={(props) => <Login {...props} />}
									/>
									<Route
										exact
										path="/unauthorized"
										component={(props) => <Unauthorized {...props} />}
									/>
									<Route path="*">
										<Redirect to="/unauthorized" />
									</Route>
								</Switch>
							</>
						) : (
							<RemoteConfigProvider>
								<AuthOrApp>
									<MonitorPedidosPendentes />
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<NotificationsWrapper>
											<ErrorBoundary>
												<Switch>
													<Route
														exact
														path={!consts.CONTEXT ? "/" : `${consts.CONTEXT}`}
													>
														{token ? (
															<Redirect to={`${consts.CONTEXT}/dashboard`} />
														) : (
															<Home {...props} />
														)}
													</Route>
													<Route exact path={`${consts.CONTEXT}/login`}>
														{token ? (
															<Redirect to={`${consts.CONTEXT}/dashboard`} />
														) : (
															<Home {...props} />
														)}
													</Route>
													<Route
														exact
														path={`/logout`}
														component={(props) => <Unauthorized {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/logout`}
														component={(props) => <Unauthorized {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/dashboard`}
														component={(props) => (
															<Dashboard
																noStores={noStores}
																lojas={lojas}
																{...props}
															/>
														)}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/new-orders`}
														component={(props) => <NovosPedidos {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/estimated`}
														component={(props) => (
															<MenuEnabledGuard menuId="estimated">
																<Previstos {...props} />
															</MenuEnabledGuard>
														)}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/ready-to-go`}
														component={(props) => <ReadyToGo {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/shipping`}
														component={(props) => <SaiuEntrega {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/returning-to-storage`}
														component={(props) => (
															<RetornarEstoque {...props} />
														)}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/picking`}
														component={(props) => <EmSeparacao {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/history`}
														component={(props) => <Historico {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/maintenance`}
														component={(props) => <Maintenance {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/all-orders`}
														component={(props) => <TodosPedidos {...props} />}
													/>
													<Route
														exact
														path={`${consts.CONTEXT}/auditoria`}
														component={(props) => {
															return storageUser.allowedByPermission(
																"AUDITORIA_LOGS",
															) ? (
																<Auditoria {...props} />
															) : (
																<Home {...props} />
															);
														}}
													/>
													{consts.DEBUG_ENABLED && (
														<Route
															exact
															path={`${consts.CONTEXT}/debug`}
															component={(props) => <Debugger {...props} />}
														/>
													)}
													<Route
														exact
														path={`${consts.CONTEXT}/:page/:orderId`}
														component={(props) => <OrderDetails {...props} />}
													/>
												</Switch>
											</ErrorBoundary>
										</NotificationsWrapper>
									</MuiPickersUtilsProvider>
								</AuthOrApp>
							</RemoteConfigProvider>
						)}
					</SnackbarProvider>
				</BrowserRouter>
			</MuiThemeProvider>
		);
	};
	return renderRoute(props);
};
